import React, { useState, useEffect } from 'react';
import { Switch, Route } from 'react-router-dom';

import PrivateRoute from '../PrivateRoute';
import Events from '../events/Events';
import Feed from '../feed/Feed';
import Groups from '../groups/Groups';
import Notifications from '../notifications/Notifications';
import Profile from '../profile/Profile';
import Login from '../login/Login';
import Registration from '../registration/Registration';
import Home from '../home/Home';
import NavigationColumn from './NavigationColumn';
import Challenges from '../challenges/Challenges';
import RecordWorkout from '../recordWorkout/RecordWorkout';
import MembershipOptionView from '../profile/MembershipOptionView'
import PaymentView from '../profile/PaymentView';
import OrderConfirmationView from '../profile/OrderConfirmationView';

import WorkoutLog from '../recordWorkout/WorkoutLog';
import Analytics from '../analytics/Analytics';
import WorkSpaceAnalytics from '../analytics/WorkSpaceAnalytics';
import ChallengeWorkSpace from '../analytics/ChallengeWorkSpace';
import ChallengeBadges from '../challenges/ChallengeBadges';

export default function NavigationWrapper() {
  return (
    <>
      <NavigationColumn />
      <Switch>
        <Route path="/" exact component={Home} />
        <Route
          path='/login'
          render={(props) => <Login {...props} />}
        />
      <PrivateRoute path="/paymentview" component={PaymentView} />
      <PrivateRoute path="/membershipoptionview" component={MembershipOptionView} />
      <PrivateRoute path="/orderconfirmationview" component={OrderConfirmationView} />
      <Route path="/registration" component={Registration} />
      <PrivateRoute path="/feed" component={Feed} />
      <PrivateRoute path="/groups" component={Groups} />
      <PrivateRoute path="/events" component={Events} />
      <PrivateRoute path="/notifications" component={Notifications} />
      <PrivateRoute path="/profile" component={Profile} />
      <PrivateRoute path="/challenges" component={Challenges} />
      <PrivateRoute path="/workoutlogs" component={WorkoutLog} />
      <PrivateRoute path="/challengebadges" component={ChallengeBadges} />
      <PrivateRoute path={`/recordworkout`} component={RecordWorkout} />
      <PrivateRoute path={"/analytics"} component={Analytics} />
      <PrivateRoute path={"/workspaceanalytics"} component={WorkSpaceAnalytics} />
      <PrivateRoute path={"/challengeworkspaceanalytics"} component={ChallengeWorkSpace} />
      </Switch>
      </>
  );
}
